import React, { FunctionComponent } from 'react';

import { Title as TitleType } from '@gojob/cms';
import Flex from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import BreakpointContainer from '../../BreakpointContainer';
import CheeryTitle from '../../CheeryTitle';

export type TitleProps = TitleType;

const useStyles = () => {
  const { spacing } = useTheme();
  return {
    root: {
      // correspond to 32px for a 6 root unit.
      // Not in the typography theme because this is
      // the only place where this is used
      fontSize: spacing(5.3),
      lineHeight: spacing(8),
    },
  } as const;
};

const Title: FunctionComponent<TitleProps> = (props) => {
  const { title, level } = props;

  const classes = useStyles();

  if (!title) {
    return null;
  }
  return (
    <Flex justifyContent="center">
      <BreakpointContainer maxWidth="lg">
        <CheeryTitle as={level} css={classes.root} variant="headline1">
          {title}
        </CheeryTitle>
      </BreakpointContainer>
    </Flex>
  );
};

export default Title;
